import { memo } from 'react';
import {
  IconValidationInvalid,
  TextInput,
  type TextInputProps,
} from '@adc/parallax-component-library';

import { buildTestId } from '~/utilities/buildTestId';

type InputProps = Omit<
  Exclude<TextInputProps, { multiline: true }>,
  'aria-label'
> & {
  isInvalid?: boolean;
  errorMessage?: string;
};

export const Input = memo(
  ({
    isInvalid = false,
    label,
    errorMessage,
    placeholder = '',
    value,
    onBlur,
    onChangeText,
    disabled,
    testID,
    inputMode,
    onFocus,
    ...props
  }: InputProps) => {
    const showsErrorMessage = isInvalid && errorMessage;

    return (
      <TextInput
        inputMode={inputMode}
        aria-label={label ?? ''}
        label={label}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        error={isInvalid}
        supportingText={showsErrorMessage ? errorMessage : undefined}
        supportingIconConfig={
          showsErrorMessage
            ? {
                icon: (
                  <IconValidationInvalid
                    testID={buildTestId({ testID, suffix: 'icon' })}
                  />
                ),
                color: '$support.danger.surfaceOnColorAlt',
              }
            : undefined
        }
        onChangeText={onChangeText}
        value={value}
        testID={testID}
        disabled={disabled}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';
